'use client';

import { Filter } from 'lucide-react';
import { useCallback } from 'react';

import { clsx } from 'clsx';

import { ICON_DEFAULT } from '@shared/constants/colors';
import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { SelectOptionType } from '@shared/types/global';
import { DefaultSelect } from '@shared/ui/DefaultSelect/DefaultSelect';
import { HStack } from '@shared/ui/Stack';

import { EXCLUDED_FILTERS } from '../../config/filters';
import { changeSortValue, changeView, openAllFiltersModal } from '../../model/slice/categorySlice';
import cls from './Sorting.module.scss';

export const Sorting = () => {
  const activeFilters = useAppSelector((state) => state.category.prevActiveFilters);
  const activeFiltersLength = Object.keys(activeFilters).filter((key) => !EXCLUDED_FILTERS.includes(key)).length;
  const view = useAppSelector((state) => state.category.view);
  const sortOptions = useAppSelector((state) => state.category.sort);
  const dispatch = useAppDispatch();

  const onGridView = () => {
    dispatch(changeView('grid'));
  };

  const onRowView = () => {
    dispatch(changeView('row'));
  };

  const onChangeSort = useCallback(
    (value: SelectOptionType) => {
      dispatch(changeSortValue(value.value));
    },
    [dispatch]
  );

  const openModalFilterHandler = () => {
    dispatch(openAllFiltersModal());
  };

  return (
    <HStack
      align={'center'}
      className={cls.wrap}
    >
      <HStack
        gap={'4'}
        align={'center'}
      >
        <div className={cls.label}>Сортировать по:</div>
        <DefaultSelect
          onChange={onChangeSort}
          options={sortOptions}
          className={cls.select}
        />

        <button
          data-testid={'all-filters-button-mobile'}
          aria-label={'Показать все фильтры'}
          onClick={openModalFilterHandler}
          className={cls.allFilter}
        >
          <Filter
            size={20}
            color={ICON_DEFAULT}
          />
          {activeFiltersLength > 0 && <div className={cls.quantity}>{activeFiltersLength}</div>}
        </button>
      </HStack>
      <HStack className={cls.view}>
        <button
          data-testid={'grid-view-button'}
          aria-label={'Включить режим отображения сеткой'}
          onClick={onGridView}
          className={clsx(cls.grid, { [cls.active]: view === 'grid' })}
        >
          <div className={cls.icon}></div>
        </button>
        <button
          data-testid={'row-view-button'}
          aria-label={'Включить режим отображения списком'}
          onClick={onRowView}
          className={clsx(cls.row, { [cls.active]: view === 'row' })}
        >
          <div className={cls.icon}></div>
        </button>
      </HStack>
    </HStack>
  );
};
